import React from "react";
import { Box, Text, Button, HStack } from "@chakra-ui/react";

const HomepageBanner = () => {
  return (
    <Box
      bg="var(--accent-dark)"
      color="white"
      py={2}
      px={4}
      textAlign="center"
      borderRadius="md"
      boxShadow="lg"
      borderBottom={"1px solid #2D3748"}
    >
      <HStack spacing={8} justify="center" align="center">
        <Text fontSize={{ base: "md", md: "lg" }}>
          🚀 We've launched WealthBee - a highly flexible tool for advanced
          trade journalling
        </Text>
        <Button
          as="a"
          href="https://wealthbee.io"
          target="_blank"
          rel="noopener noreferrer"
          colorScheme="orange"
          size="sm"
          borderRadius="full"
          px="6"
        >
          Learn More
        </Button>
      </HStack>
    </Box>
  );
};

export default HomepageBanner;
